import React, { FC } from 'react';
import Modal from "react-bootstrap/Modal";
import { TemplateStyle } from "../Container/quickbetXHelpers";
import { useTranslation } from "react-i18next";
import './QuickbetXSettingsModal.css';

type TicketSettings = {
    odds: {odds: number | null, direction: string } | null;
    markets: string[];
    events: { id: string; market: string }[];
};
interface QS {
    show: boolean,
    styles: TemplateStyle
    toggleMarketFilter: (market: string) => void;
    setOddsFilterValue: (odds: number|null) => void;
    hide: (value: boolean) => void;
    ticketSettings: TicketSettings
}

const QuickbetXSettingsModal: FC<QS> = ({
                                            hide,
                                            show,
                                            toggleMarketFilter,
                                            setOddsFilterValue,
                                            ticketSettings,
                                            styles }) => {

    const { t } = useTranslation();
    return (
        <Modal
            show={show}
            onHide={() => hide(false)}
            dialogClassName="quickbetx-bottom-sheet"
            contentClassName="quickbetx-bottom-sheet-content"
            aria-labelledby="quickbetx-modal-title"
            centered={false}
        >
            <Modal.Header
                closeButton
                style={{
                    backgroundColor: styles.colors.blockTitleBgColor,
                    color: styles.colors.fontTitleColor,
                    fontFamily: styles.fonts.titleFontFamily
                }}
            >
                <Modal.Title id="quickbetx-modal-title">
                    {t('quickbet.markets.betSettings')}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body
                style={{
                    backgroundColor: styles.colors.mainBgColor,
                    color: styles.colors.fontColor
                }}
            >
                <div className="text-center p-2">
                    <h4 className="text-center rounded title p-1"
                        style={{
                            color: styles.colors.fontTitleColor,
                            fontSize: styles.fonts.titleFontSize,
                            fontFamily: styles.fonts.titleFontFamily,
                            backgroundColor: styles.colors.blockTitleBgColor,
                            textTransform: 'uppercase'
                        }}
                    >
                        {t('quickbet.markets.oddsFilter')}:
                    </h4>
                    <button
                        style={{
                            marginRight: '5px',
                            fontSize: '10px',
                            fontWeight: 'bold',
                            color: ticketSettings.odds?.odds === 1.4 ? styles.colors.buttonBGColor : styles.colors.buttonFontColor,
                            backgroundColor: ticketSettings.odds?.odds === 1.4 ? styles.colors.buttonFontColor : styles.colors.buttonBGColor,
                        }}
                        className="btn w-25"
                        onClick={() => setOddsFilterValue(1.4)}
                    >
                        <div>
                            {t('quickbet.markets.oddsUnder')}
                        </div>
                        <div>
                            1.4
                        </div>
                    </button>
                    <button
                        style={{
                            fontSize: '10px',
                            marginRight: '5px',
                            fontWeight: 'bold',
                            color: ticketSettings.odds?.odds === 1.9 ? styles.colors.buttonBGColor : styles.colors.buttonFontColor,
                            backgroundColor: ticketSettings.odds?.odds === 1.9 ? styles.colors.buttonFontColor : styles.colors.buttonBGColor,
                        }}
                        className="btn w-25"
                        onClick={() => setOddsFilterValue(1.9)}
                    >
                        <div>{t('quickbet.markets.oddsUnder')}</div>
                        <div> 1.9</div>
                    </button>

                    <button
                        style={{
                            fontSize: '10px',
                            color: styles.colors.buttonFontColor,
                            fontWeight: 'bold',
                            backgroundColor: styles.colors.buttonBGColor,
                            textTransform: 'uppercase'
                        }}
                        className="btn w-25"
                        onClick={() => setOddsFilterValue(null)}
                    >
                        <div>{t('quickbet.markets.all')}</div>
                        <div>{t('quickbet.markets.games')}</div>
                    </button>

                    <h4 className="text-center rounded title p-1 mt-3"
                        style={{
                            color: styles.colors.fontTitleColor,
                            fontSize: styles.fonts.titleFontSize,
                            fontFamily: styles.fonts.titleFontFamily,
                            backgroundColor: styles.colors.blockTitleBgColor,
                            textTransform: 'uppercase'
                        }}
                    >
                        {t('quickbet.markets.marketFilter')}:
                    </h4>
                    <button
                        style={{
                            marginRight: '5px',
                            padding: '13px 0',
                            fontSize: '10px',
                            color:  styles.colors.buttonFontColor,
                            backgroundColor: styles.colors.buttonBGColor,
                            fontWeight: 'bold',
                        }}
                        className="btn w-25"
                        onClick={() => toggleMarketFilter('ALL')}
                    >
                        <div>
                            {t('quickbet.markets.allMarkets')}
                        </div>
                    </button>
                    <button
                        style={{
                            fontSize: '10px',
                            marginRight: '5px',
                            fontWeight: 'bold',
                            color: ticketSettings.markets.includes("MRFT") ? styles.colors.buttonBGColor : styles.colors.buttonFontColor,
                            backgroundColor: ticketSettings.markets.includes("MRFT") ? styles.colors.buttonFontColor : styles.colors.buttonBGColor,
                        }}
                        className="btn w-25"
                        onClick={() => toggleMarketFilter('MRFT')}
                    >
                        <div>{t('quickbet.markets.result')}</div>
                        <div>1X2</div>
                    </button>
                    <button
                        style={{
                            fontSize: '10px',
                            marginRight: '5px',
                            fontWeight: 'bold',
                            color: ticketSettings.markets.includes("OUFT") ? styles.colors.buttonBGColor : styles.colors.buttonFontColor,
                            backgroundColor: ticketSettings.markets.includes("OUFT") ? styles.colors.buttonFontColor : styles.colors.buttonBGColor,
                        }}
                        className="btn w-25"
                        onClick={() => toggleMarketFilter('OUFT')}
                    >
                        <div>{t('quickbet.markets.goals')}</div>
                        <div>{t('quickbet.markets.over')}/{t('quickbet.markets.under')}</div>
                    </button>
                    <div className='mt-2'>
                        <button
                            style={{
                                fontSize: '10px',
                                marginRight: '5px',
                                fontWeight: 'bold',
                                color: ticketSettings.markets.includes("BTTSFT") ? styles.colors.buttonBGColor : styles.colors.buttonFontColor,
                                backgroundColor: ticketSettings.markets.includes("BTTSFT") ? styles.colors.buttonFontColor : styles.colors.buttonBGColor,
                            }}
                            className="btn w-25"
                            onClick={() => toggleMarketFilter('BTTSFT')}
                        >
                            <div>{t('quickbet.markets.bothTeams')}</div>
                            <div>{t('quickbet.markets.score')} GG/NG</div>
                        </button>
                        <button
                            style={{
                                fontSize: '10px',
                                padding: '13px 0',
                                fontWeight: 'bold',
                                marginRight: '5px',
                                color: ticketSettings.markets.includes("DCFH") ? styles.colors.buttonBGColor : styles.colors.buttonFontColor,
                                backgroundColor: ticketSettings.markets.includes("DCFH") ? styles.colors.buttonFontColor : styles.colors.buttonBGColor,
                            }}
                            className="btn w-25"
                            onClick={() => toggleMarketFilter('DCFH')}
                        >
                            <div>{t('quickbet.markets.DCFH')}</div>
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default QuickbetXSettingsModal;
